import React, { useState, useEffect } from "react";
import {
  Box,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  AppBar,
  Typography,
  IconButton,
  Divider,
  useTheme,
  useMediaQuery,
  styled,
  CssBaseline,
  Tooltip,
  Collapse,
  Button,
} from "@mui/material";
import {
  Dashboard,
  Security,
  Store,
  Settings,
  Notifications,
  ShoppingCart,
  People,
  ListAlt,
  ExitToApp,
  AccountCircle,
  SupervisorAccount,
  Science,
  Category,
  ExpandLess,
  ExpandMore,
  Subscriptions,
  LocalOffer,
  WorkspacePremium,
  EventNote,
  ViewCarousel,
  AccountBalanceWallet,
  Palette,
  Person,
  Group,
  VerifiedUser,
  RemoveCircleOutline,
  Block,
  Redeem,
  Sell,
  StoreMallDirectory,
  EditNote,
  Timeline,
  Inventory2,
  ViewModule,
  Apps,
  Assessment,
  AddCircleOutline,
  Groups,
  Slideshow,
  CardGiftcard,
  Discount,
  EventAvailable,
  NotificationsActive,
  Article,
  SettingsApplications,
  AppSettingsAlt,
  ReceiptLong,
  ConfirmationNumber,
} from "@mui/icons-material";
import HelpCenterIcon from '@mui/icons-material/HelpCenter';
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import { IoReorderThree } from "react-icons/io5";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import InstaLogo from "../../Images/InstaLogo.png";
import LanguageDropdown from "../Comman/LanguageDropdown";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { IoDiamond } from "react-icons/io5";
import Dropdownlist from "../MainScreens/Admin/Dropdownlist";
import { useDispatch, useSelector } from "react-redux";
import { persistor } from "../../redux/store";
import auth from "../../configs/auth";
import DiamondPointsOrder from "../MainScreens/RedeemSell/DiamondPointsOrder";
import ViewListIcon from '@mui/icons-material/ViewList';
import { getAppConfig } from "../../redux/Configuration/configurationSlice";
import moment from "moment";
import { checkActivePlanRequest } from "../../redux/sagas/Subscription/SubscriptionSlice";
import { canShowPermission } from "../MainScreens/Permissions/permissionObject";
import CoPresentIcon from "@mui/icons-material/CoPresent";
import PersonAddIcon from '@mui/icons-material/PersonAdd';  

const drawerWidth = 240; //fixed the drawer width

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
  justifyContent: "flex-end",
}));



export default function Sidebar() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

   const { active_plan = [] } = useSelector(
        (state) => state.subscriptionPlan || {}
      );
      const configData = useSelector((state) => state.appConfig.configData||{});

  const handleLogout = async () => {
    const confirmLogout = window.confirm(t("common.confirmLogout"));
    if (!confirmLogout) return;

    localStorage.clear();
    sessionStorage.clear();
    dispatch({ type: "RESET_APP" });
    await persistor.purge();

    // Direct navigation fallback
    window.location.replace("/login");
  };
  const [sidebarMessageKey, setSidebarMessageKey] = useState(null);
  const [sidebarMessageCount, setSidebarMessageCount] = useState(null);
  const [activePlan,setActivePlan]=useState([]);


  const [selectedJewellerId, setSelectedJewellerId] = useState(() => {
    return sessionStorage.getItem(auth.selectedJeweller) || "";
  });

  const [email, setEmail] = useState("");

  useEffect(() => {
    const storedEmail = localStorage.getItem("userEmail");
    if (storedEmail) {
      setEmail(storedEmail);
    }
  }, []);
  const subscriptionExpired =
  localStorage.getItem("subscriptionExpired") === "true";
  const requireJewellerDocument =
    localStorage.getItem("hasjewellerDocument") === "false";
  //   useEffect(() => {
  //   if (active_plan) {
  //     setActivePlan(active_plan);
  //   }
  // }, [active_plan]);
  
   useEffect(() => {
  if (!active_plan.length) return;

  const hasPrepaid = active_plan.some(sub => sub.status === "PrePaid");
  const activePlanData = active_plan.find(sub => sub.status === "Active");

  if (!hasPrepaid && activePlanData) {
  const notifyDays = Number(configData?.gracePeriodDays?.notifyJewellerDays || 0);
  if (!notifyDays) return;

  const today = moment().startOf("day").valueOf();
  const endDate = moment(activePlanData.endDate).endOf("day").valueOf();
  if (!endDate) return;

const daysLeft = Math.floor((endDate - today) / (1000 * 60 * 60 * 24));

  if (daysLeft < 1 && daysLeft >= 0) {
    setSidebarMessageKey("common.subscriptionExpiresToday");
    setSidebarMessageCount(null);
  } else if (daysLeft <= notifyDays && daysLeft > 0) {
    setSidebarMessageKey("common.subscriptionExpiresIn");
    setSidebarMessageCount(daysLeft);
  } else {
    setSidebarMessageKey(null);
    setSidebarMessageCount(null);
  }
}

}, [active_plan]); //  depend on Redux state 



  const handleJewellerChange = (event) => {
    const value = event.target.value;
    sessionStorage.setItem(auth.selectedJeweller, value);
    dispatch(getAppConfig({
      onSuccess: () => {
        window.location.reload();
      },
    }));
  };

  const [drawerOpen, setDrawerOpen] = useState(true);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [openMenus, setOpenMenus] = useState({});
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const location = useLocation();
  const [permissions, setPermissions] = useState({});


  // Check if user has only booking bullion related permissions
  const hasOnlyBookingBullionPermissions = () => {
    const requiredPermissions = ["instalaxmiPermission", "bookingTransaction", "bookingBullion", "bookingReport"];
    const hasRequiredPerms = requiredPermissions.every(perm => 
      permissions[perm]?.view || (perm === "bookingBullion" && permissions[perm]?.create)
    );
    
    // Check that user doesn't have other significant permissions (excluding instalaxmiPermission)
    const otherPermissions = Object.keys(permissions).filter(
      perm => !requiredPermissions.includes(perm)
    );
    const hasOtherPerms = otherPermissions.some(perm => {
      const permObj = permissions[perm];
      return permObj?.view || permObj?.create || permObj?.edit || permObj?.delete;
    });
    
    return hasRequiredPerms && !hasOtherPerms;
  };

  const canViewStore = canShowPermission(permissions, "storemanagement", "view");
  const canViewJeweller = canShowPermission(permissions, "jeweller", "view");
  const canViewTraining = canShowPermission(permissions, "training", "view");
  const canViewLeads = canShowPermission(permissions, "leads", "view");

const menuItems = [
  {
    textKey: "sidebar.dashboard",
    key: "dashboard",
    icon: <Dashboard />,
    path: "/dashboard",
  },
  {
    textKey: "sidebar.metalManagement",
    icon: <Science />,
    key: "metaldetails",
    path: "/MetalManagementPage",
  },
  {
    textKey: "sidebar.transactions",
    icon: <AccountBalanceWallet />,
    key: "transaction",
    path: "/TransactionsPage",
  },
  {
    textKey: "sidebar.appManagement",
    icon: <Apps />,
    key: "appManagement",
    path: "/AppManagementPage",
  },
  {
    textKey: "sidebar.productsManagement",
    icon: <Category />,
    key: "productmanagement",
    path: "/ProductsManagementPage",
  },
  {
    textKey: "sidebar.planManagement",
    icon: <EventNote />,
    key: "planManagement",
    path: "/PlanManagementPage",
  },
  {
    textKey: "sidebar.gifts",
    icon: <CardGiftcard />,
    key: "gifts",
    path: "/GiftsPage",
  },
  {
    textKey: "sidebar.customers",
    icon: <IoDiamond />,
    key: "Customer",
    path: "/CustomersPage",
  },
  {
    textKey: "sidebar.admin",
    icon: <SupervisorAccount />,
    key: "userManagement",
    path: "/AdminPage",
  },
  {
    textKey: "sidebar.store",
    icon: <Store />,
    key: "storemanagement",
    path: "/CreateStoreList",
  },
  {
    textKey: "sidebar.offers",
    icon: <LocalOffer />,
    key: "offers",
    path: "/Offers",
  },
  {
    textKey: "sidebar.jeweller",
    key: "jeweller",
    icon: <People />,
    path: "/CreateJwellerList",
  },
  {
    textKey: "sidebar.subscriptions",
    icon: <Subscriptions />,
    key: "subscription",
    path: "/SubscriptionsPage",
  },
  {
    textKey: "sidebar.settings",
    icon: <Settings />,
    key: "settings",
    path: "/SettingsPage",
  },
   {
    textKey: "sidebar.ticket",
    icon: <HelpCenterIcon />,
    key: "ticket",
    path: "/TicketPage",
   },
  {
    textKey: "sidebar.bookingBullionPage",
    icon: <Settings />,
    key: "bookingBullionPage",
    path: "/BookingBullionPage",
  },
   {
    textKey: "sidebar.training",
    icon: <CoPresentIcon />,
    key: "training",
    path: "/Training",
   },
   {
    textKey: "sidebar.leads",
    icon: <PersonAddIcon />,
    key: "leads",
    path: "/FollowupAndLeadsPage",
  },
];

  useEffect(() => {
    const storedPermissions = localStorage.getItem("userPermissions");
    if (storedPermissions) {
      setPermissions(JSON.parse(storedPermissions));
    }
  }, []);

  useEffect(() => {
    if (
      requireJewellerDocument &&
      location.pathname !== "/UploadJewellerDocument"
    ) {
      navigate("/UploadJewellerDocument", { replace: true });
    }
  }, [requireJewellerDocument, location.pathname, navigate]);

 
  const filterMenuItems = (items) => {
    // If user has only booking bullion related permissions, show only booking bullion page
    if (hasOnlyBookingBullionPermissions()) {
      return items.filter((item) => item.key === "bookingBullionPage");
    }
    
    return items.filter((item) => {
  if (subscriptionExpired) {

      // special mapping for subscription menu
      if (item.key === "subscription") {
        return canShowPermission(
          permissions,
          "subscriptionList",
          "view"
        );
      }

      // hide all other menus
      return false;
    }
      if (item.key === "storemanagement") return canViewStore;
      if (item.key === "jeweller") return canViewJeweller;
      if (item.key === "training") return canViewTraining;
      if (item.key === "leads") return  canViewLeads;
      return true;
    });
  };

  const filteredMenuItems = filterMenuItems(menuItems);

  const toggleDrawer = () => {
    if (isMobile) setMobileOpen(!mobileOpen);
    else setDrawerOpen(!drawerOpen);
  };

  const renderMenuItems = (items, depth = 0) =>
    items.map((item) => {
      const hasChildren = Array.isArray(item.children);

      const paddingLeft = 2 + depth * 2;
      const fontSize =
        depth === 0 ? "0.875rem" : depth === 1 ? "0.875rem" : "0.875rem"; // Size based on depth

      if (hasChildren) {
        return (
          <React.Fragment key={item.key}>
            <ListItem
              button
              onClick={() => {
                if (item.key) {
                  setOpenMenus((prev) => ({
                    ...prev,
                    [item.key]: !prev[item.key],
                  }));
                }
              }}
              sx={{ pl: paddingLeft }}
            >
              <ListItemIcon sx={{ minWidth: 36 }}>
                {item.icon &&
                  React.cloneElement(item.icon, {
                    sx: { fontSize: "1.275rem" },
                  })}
              </ListItemIcon>
              <ListItemText
                primary={item.textKey ? t(item.textKey) : item.text}
                primaryTypographyProps={{
                  fontSize,
                  fontWeight: 500,
                  color:
                    depth === 0 ? "#000" : depth === 1 ? "#7028DA" : "#9E3ED7",
                }}
              />
              {openMenus[item.key] ? (
                <ExpandLess sx={{ fontSize: 20 }} />
              ) : (
                <ExpandMore sx={{ fontSize: 20 }} />
              )}
            </ListItem>

            <Collapse in={openMenus[item.key]} timeout="auto" unmountOnExit>
              <List
                component="div"
                disablePadding
                sx={{
                  "& .MuiListItemText-primary": {
                    color: "#000",
                  },
                }}
              >
                {renderMenuItems(item.children, depth + 1)}
              </List>
            </Collapse>
          </React.Fragment>
        );
      }

      return (
        <Tooltip
          title={item.textKey ? t(item.textKey) : item.text}
          placement="right"
          followCursor
          arrow
          key={item.key}
          componentsProps={{
            tooltip: {
              sx: {
                background:
                  "linear-gradient(90deg, #7028DA 0%, #9E3ED7 76.93%)",
                color: "#fff",
                fontSize: "14px",
                fontWeight: 500,
                borderRadius: "8px",
                padding: "10px",
              },
            },
            arrow: { sx: { color: "#7028DA" } },
          }}
        >
          <ListItem
            button
            component={Link}
            to={item.path}
            selected={location.pathname === item.path}
            onClick={() => isMobile && setMobileOpen(false)}
            sx={{
              pl: paddingLeft,
              backgroundColor:
                location.pathname === item.path ? "#e2d4fb" : "transparent",
              //  borderRadius: "6px",
              "&:hover": {
                backgroundColor:
                  location.pathname === item.path ? "#ac87ebff" : "#f5f5f5",
              },
            }}
          >
            <ListItemIcon sx={{ minWidth: 36 }}>
              {item.icon &&
                React.cloneElement(item.icon, {
                  sx: { fontSize: "0.875rem" },
                })}
            </ListItemIcon>
            <ListItemText
              primary={item.textKey ? t(item.textKey) : item.text}
              primaryTypographyProps={{
                fontSize,
                fontWeight: 500,
                color:
                  depth === 0 ? "#000" : depth === 1 ? "#7028DA" : "#9E3ED7",
              }}
            />
          </ListItem>
        </Tooltip>
      );
    });

  const drawerContent = (
    <Box display="flex" flexDirection="column" height="100%">
      <Box
        sx={{
          flexGrow: 1,
          height: "350px",
          overflowY: "auto",
          "&::-webkit-scrollbar": { width: "6px" },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#c1c1c1",
            borderRadius: "4px",
          },
          "&::-webkit-scrollbar-track": { backgroundColor: "#f0f0f0" },
        }}
      >
        <List>{renderMenuItems(filteredMenuItems)}</List>
      </Box>
      <Divider />
      <Box sx={{ p: 2, flexShrink: 0 }}>
        {canShowPermission(permissions, "jewellerPermission", "view") && (
          <Box display="flex" alignItems="center" mb={1}>
            <Box
              sx={{
                mr: 1,
                width: "20%",
                color: "#FFD700",
                fontSize: "0.875rem",
              }}
            >
              <IoDiamond />
            </Box>
            <Box>
              <Dropdownlist
                selectedId={selectedJewellerId}
                onChange={handleJewellerChange}
              />
            </Box>
          </Box>
        )}
        <Box display="flex" alignItems="center">
          <Box sx={{ width: "20%" }}>
            <AccountCircle sx={{ fontSize: "1.5rem", color: "gray" }} />
          </Box>
          <Box sx={{ width: "70%" }}>
            <Typography
              variant="subtitle1"
              fontWeight="bold"
              fontSize="0.875rem"
            >
              {t("common.admin")}
            </Typography>
            <Tooltip
              title={email}
              componentsProps={{
                tooltip: {
                  sx: {
                    backgroundColor: "#cdcdcd",
                    color: "#000",
                    fontSize: "0.875rem",
                    borderRadius: "8px",
                    padding: "8px 12px",
                    boxShadow: 3,
                  },
                },
              }}
            >
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{
                  fontSize: "0.875rem",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  maxWidth: "150px",
                  display: "block",
                }}
              >
                {email}
              </Typography>
            </Tooltip>
          </Box>
          <Box sx={{ width: "15%" }}>
            <IconButton sx={{ ml: "auto" }} onClick={handleLogout}>
              <ExitToApp />
            </IconButton>
          </Box>
        </Box>
      </Box>
    </Box>
  );

  return (
    <>
      <CssBaseline />
      <AppBar
        position="fixed"
        sx={{
          zIndex: (theme) => theme.zIndex.drawer + 1,
          background: "linear-gradient(90deg, #7028DA 0%, #9E3ED7 76.93%)",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", height: "64px" }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: drawerWidth,
              background: "#fff",
              height: "100%",
            }}
          >
            <img
              src={InstaLogo}
              alt="Logo"
              style={{
                maxHeight: "40px",
                objectFit: "contain",
              }}
            />
          </Box>

          {!requireJewellerDocument && (
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={toggleDrawer}
            sx={{
              ml: 0,
              // background: "white",
              color: "#fff",
              width: "55px",
              height: "55px",
              borderRadius: "0px",
              "&:hover": {
                color: "#f0e7ff",
              },
            }}
          >
            <IoReorderThree fontSize={33} />
          </IconButton>
          )}
        {sidebarMessageKey && (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      gap: 2,
    }}
  >
    <Typography
      sx={{
        color: "white",
        ml: 1,
        fontSize: "0.9rem",
        background: "rgba(255,255,255,0.2)",
        px: 1.5,
        py: 0.5,
        borderRadius: "6px",
        backdropFilter: "blur(4px)",
        transition: "all 0.3s",
      }}
    >
      {sidebarMessageCount != null ? t(sidebarMessageKey, { count: sidebarMessageCount }) : t(sidebarMessageKey)}
    </Typography>

    {/* Renew Button */}
    <Button
      variant="contained"
      onClick={() => navigate("/Subscription")}
      sx={{
        background: "#FFEB3B",
        color: "#000",
        fontWeight: "bold",
        textTransform: "uppercase",
        px: 2.5,
        py: 0.4,
        borderRadius: "20px",
        boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
        "&:hover": {
          background: "#FDD835",
        },
      }}
    >
      {t("common.renew")}
    </Button>
  </Box>
)}
          <Box sx={{ marginLeft: "auto", display: "flex", alignItems: "center", mr: 2 }}>
            {requireJewellerDocument && (
              <IconButton color="inherit" onClick={handleLogout} sx={{ mr: 1 }}>
                <ExitToApp />
              </IconButton>
            )}
            <LanguageDropdown />
          </Box>
        </Box>
      </AppBar>

      <Box sx={{ paddingTop: { xs: "56px", sm: "64px" } }}></Box>

      {!requireJewellerDocument && (
      <Drawer
        variant="persistent"
        open={drawerOpen}
        sx={{
          display: { xs: "none", md: "block" },
          "& .MuiDrawer-paper": {
            width: drawerWidth,
            background: "#fff",
            boxSizing: "border-box",
            transition: theme.transitions.create("width", {
              easing: theme.transitions.easing.sharp,
              duration: theme.transitions.duration.enteringScreen,
            }),
          },
        }}
      >
        <DrawerHeader>
          <IconButton onClick={toggleDrawer}>
            {theme.direction === "ltr" ? (
              <ChevronLeftIcon fontSize="45px" />
            ) : (
              <ChevronRightIcon />
            )}
          </IconButton>
        </DrawerHeader>
        {drawerContent}
      </Drawer>
      )}

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          ml: {
            md:
              !requireJewellerDocument && drawerOpen
                ? `${drawerWidth}px`
                : "0px",
          },
          transition: theme.transitions.create("margin", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
          }),
        }}
      >
        <DrawerHeader />
      </Box>
    </>
  );
}
